export const CUSTOMER_RMA_TYPE = "CustomerRma";
export const VENDOR_RMA_TYPE = "VendorRma";
export const APPROVED_STATUS = "approved";
export const DENIED_STATUS = "denied";

export const COST_ADJUSTMENT = "cost_adjustment";
export const CHARGE_NO_FAULT_FOUND_FEE = "charge_no_fault_found_fee";
export const CREDIT_AMOUNT = "credit_amount";
export const CREDIT_DENIED = "credit_denied";
export const CREDIT_ISSUED = "credit_issued";
export const CREDIT_REQUESTED = "credit_requested";
export const CUSTOMER_RMAS = "customer_rmas";
export const CUSTOMER_RMA_CREDIT_AMOUNT = "customer_rma_credit_amount";
export const FULL_CREDIT_AMOUNT = "full_credit_amount";
export const FULL_CREDIT_REQUESTED = "full_credit_requested";
export const NO_FAULT_FOUND_FEE = "no_fault_found_fee";
export const NO_FAULT_FOUND_FEE_INVOICED = "no_fault_found_fee_invoiced";
export const WARRANTY_CHARGES_INVOICED = "warranty_charges_invoiced";
export const WARRANTY_CONSIDERATION = "warranty_consideration";
export const WARRANTY_STATUS = "warranty_status";
export const VENDOR_RMA_NUMBER = "vendor_rma_number";
export const VENDOR_WARRANTY_AMOUNT = "vendor_warranty_amount";
export const VENDOR_WARRANTY_AMOUNT_PAID = "vendor_warranty_amount_paid";
export const REPAIR_STATION_WARRANTY_STATUS = "repair_station_warranty_status";

export const WARRANTY_STATUSES = {
  [APPROVED_STATUS]: {
    label: "Approved"
  },
  [DENIED_STATUS]: {
    label: "Denied"
  }
};

export const ATTACHMENT_TYPES = {
  vendor: {
    vendor_full_credit_request: {
      label: "Vendor Full Credit Request"
    },
    vendor_partial_credit_request: {
      label: "Vendor Partial Credit Request"
    },
    rma_approval_form: {
      label: "RMA Approval Form"
    },
    other: {
      label: "Other"
    }
  },
  customer: {
    customer_rma_approval_form: {
      label: "Customer RMA Approval Form"
    },
    customer_full_credit_request: {
      label: "Customer Full Credit Request"
    },
    customer_partial_credit_request: {
      label: "Customer Partial Credit Request"
    },
    customer_correspondence: {
      label: "Customer Correspondence"
    },
    failure_report: {
      label: "Failure Report"
    },
    other: {
      label: "Other"
    }
  }
};

export const RECORD_TYPES = {
  SalesOrder: "SO",
  RepairOrder: "RO"
};

export const REASONS = {
  failed_test_or_install: {
    label: "Unit failed at test or install"
  },
  no_longer_required: {
    label: "Unit no longer required"
  },
  wrong_unit_ordered: {
    label: "Wrong unit ordered"
  },
  failed_inspection: {
    label: "Unit failed incoming inspection"
  },
  condition: {
    label: "Unit is rejected due to condition"
  },
  ber_at_shop: {
    label: "BER At Shop"
  },
  vendor_to_send_to_shop: {
    label: "Vendor to send to shop"
  },
  other: {
    label: "Other"
  }
};

export const CUSTOMER_RMA_REASONS = {
  failed_test_or_install: {
    label: "Unit failed at test or install"
  },
  no_longer_required: {
    label: "Unit no longer required"
  },
  wrong_unit_ordered: {
    label: "Wrong unit ordered"
  },
  failed_inspection: {
    label: "Unit failed incoming inspection"
  },
  condition: {
    label: "Unit is rejected due to condition"
  },
  cannot_accept_paperwork: {
    label: "Cannot accept paperwork"
  },
  unit_failed_during_operation: {
    label: "Unit failed during operation"
  },
  other: {
    label: "Other"
  }
};

export const CANCELLATION_REASONS = [
  {
    value: "failed_test_or_install",
    text: "Unit failed at test or install"
  },
  {
    value: "no_longer_required",
    text: "Unit no longer required"
  },
  {
    value: "wrong_unit_ordered",
    text: "Wrong unit ordered"
  },
  {
    value: "failed_inspection",
    text:
      "Unit failed incoming inspection unit is rejected due to condition and we will accept the unit back and stock without sending to the shop."
  },
  {
    value: "other",
    text: "Other"
  }
];

export const PARTIAL_CREDIT_STATUS = "partial_credit_status";
export const PARTIAL_CREDIT_AMT = "partial_credit_amt";
export const REQUESTED = "requested";
export const PARTIAL_CREDIT_ACCEPTED = "accepted";
export const PARTIAL_CREDIT_REQUESTED = "partial_credit_requested";
export const PARTIAL_CREDIT_DENIED = "denied";
export const PARTIAL_CREDIT_CLOSED_BEFORE_REPLY =
  "ro_closed_before_vendor_reply";

export const PARTIAL_CREDIT_STATUSES = {
  requested: "Requested",
  accepted: "Accepted",
  denied: "Denied",
  ro_closed_before_vendor_reply: "RO Closed Before Vendor Reply"
};



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/constants.js